<template>
<!--  16-2引用的-->
  <div class="chat-box">
    <!-- <div class="header">聊天室人数:{{ count }}</div>

    <div>
      <div class="msg-box" v-for="(item, index) in list" :key="index">
        <span>{{ item.content }}</span>
        <div class="header-avtor"></div>
      </div>
    </div>

    <div class="bottom">
      <div class="down">
        <input type="text" v-model="contentText" />
        <button ref="btn" @click="sendText">发送</button>
      </div>
    </div> -->

    <!-- search 聊天记录 -->
    <div class="search">
      <el-input
        :placeholder="chatHistory"
        prefix-icon="el-icon-search"
        v-model="searchInput"
        @change="searchMessage"
      >
      </el-input>
    </div>
    <!-- 显示信息部分 -->
    <div class="title-main">
        <div
          class="message-list-li"
            v-for="(item, index) in contentSendList"
          :key="index"
        >
            <!-- 角色为0 -->
            <div class="message-avt-img-css" v-if="item.role === 0">
              <img :src="item.avatarImg" alt="" />
            </div>
            <div class="message-li-box" v-if="item.role === 0">
              {{ item.title }}
            </div>
          <div class="message-li-text" v-if="item.role === 0">
            {{item.text}}
          </div>
            <!-- 角色为1 -->
            <div class="message-avt-img-css1" v-if="item.role === 1">
              <img :src="item.avatarImg" alt="" />
            </div>
            <div class="message-li-box1" v-if="item.role === 1">
              {{ item.title }}
            </div>
            <div class="message-li-text1" v-if="item.role === 1">
              {{item.text}}
            </div>
        </div>
    </div>
    <!-- 发送信息部分 -->
<!--    <div class="send-message">
      <div class="send-message-main">
        <div class="img-avt">
          <img src="../assets/send-avt.png" alt="" />
        </div>
        <div class="search-main-css">
          <el-input
            v-model="contentText"
            :placeholder="pleaseEnterMessage"
          ></el-input>
        </div>
        <div class="send-button-css" @click="sendMessage">
          <img src="../assets/sendFly.png" alt="" />
        </div>
      </div>
    </div>-->

  </div>
</template>
<script>
export default {
  data() {
    return {
      searchInput: "", //搜索聊天input值
      contentText: "", // input输入的值
      contentSendList: [
        {
          title: "お世話になります", //信息内容
          text:"“关于大至急・看”求职信息",
          role: 1, //判断是自己还是对话那个人
          avatarImg: require("../assets/otherSendAvt.png"), //头像图片
        },
        {
          title: "こんにちは！", //信息内容
          text:"“关于大至急・看”求职信息",
          role: 0, //判断是自己还是对话那个人
          avatarImg: require("../assets/2unsplash_OH2S9XAcLhc.png"), //头像图片
        },
        {
          title: "内定！おめでとう", //信息内容
          text:"关于大至急・看”求职信息",
          role: 0, //判断是自己还是对话那个人
          avatarImg: require("../assets/2unsplash_OH2S9XAcLhc.png"), //头像图片
        },
        {
          title: "わぁ！ありがとうございます", //信息内容
          text:"“关于大至急・看”简历信息",
          role: 1, //判断是自己还是对话那个人
          avatarImg: require("../assets/otherSendAvt.png"), //头像图片
        },
        {
          title: "内定！おめでとう", //信息内容
          text:"“关于大至急・看”简历信息",
          role: 0, //判断是自己还是对话那个人
          avatarImg: require("../assets/2unsplash_OH2S9XAcLhc.png"), //头像图片
        },
        {
          title: "わぁ！ありがとうございます", //信息内容
          text:"“关于大至急・看”学校信息",
          role: 1, //判断是自己还是对话那个人
          avatarImg: require("../assets/otherSendAvt.png"), //头像图片
        },
        {
          title: "是非是非\nまた、中国人先輩も待っていますよ", //信息内容
          text:"“关于大至急・看”学校信息",
          role: 0, //判断是自己还是对话那个人
          avatarImg: require("../assets/2unsplash_OH2S9XAcLhc.png"), //头像图片
        },
        {
          title: "安心しました！行きます！", //信息内容
          text:"“关于大至急・看”岗位信息",
          role: 1, //判断是自己还是对话那个人
          avatarImg: require("../assets/otherSendAvt.png"), //头像图片
        },
        {
          title: "内定！おめでとう", //信息内容
          text:"“关于大至急・看”岗位信息",
          role: 0, //判断是自己还是对话那个人
          avatarImg: require("../assets/2unsplash_OH2S9XAcLhc.png"), //头像图片
        },
        {
          title: "わぁ！ありがとうございます", //信息内容
          text:"“关于大至急・看”医疗机构信息",
          role: 1, //判断是自己还是对话那个人
          avatarImg: require("../assets/otherSendAvt.png"), //头像图片
        },
        {
          title: "是非是非\n" +
            "また、中国人先輩も待っていますよ", //信息内容
          text:"“关于大至急・看”医疗机构信息",
          role: 0, //判断是自己还是对话那个人
          avatarImg: require("../assets/send-avt.png"), //头像图片
        },
        {
          title: "安心しました！行きます！", //信息内容
          text:"“关于大至急・看”应聘信息",
          role: 1, //判断是自己还是对话那个人
          avatarImg: require("../assets/otherSendAvt.png"), //头像图片
        },
      ], //聊天信息列表
    };
  },
  computed: {
    chatHistory() {
      return this.$t("chatHistory");
    },
    pleaseEnterMessage() {
      return this.$t("pleaseEnterMessage");
    },
  },
  created() {
    // this.getUserId();
  },
  mounted() {
    // this.initWebsocket();
  },
  updated() {},
  methods: {
    //发送信息
    sendMessage() {
      console.log(this.contentText);
    },
    //搜索聊天记录
    searchMessage() {
      console.log(this.searchInput);
    },
    // getUserId() {
    //   let time = new Date().getTime();
    //   this.userId = time;
    // },
    // 滚动到底部
    // scrollBottm() {
    //   el.scrollTop = el.scrollHeight;
    //   console.info(el.scrollHeight);
    // },
    // 发送聊天消息
    // sendText() {
    //   let _this = this;
    //   if (!_this.contentText) {
    //     return false;
    //   }
    //   let params = {
    //     userId: _this.userId,
    //     msg: _this.contentText,
    //   };
    //   if (_this.ws.readyState == 0
    //   ) {
    //     _this.ws.send(JSON.stringify(params)); // 调用WebSocket send()发送信息的方法
    //   }
    //   _this.contentText = "";
    // },
    // initWebsocket() {
    //   let _this = this;
    //   // 判断页面有没有存在websocket连接
    //   if (window.WebSocket) {
    //     let ws = new WebSocket("ws://localhost:8080");
    //     _this.ws = ws;
    //     console.log(ws);
    //     ws.onopen = function (e) {
    //       console.log("服务器连接成功");
    //     };
    //     ws.onclose = function () {
    //       console.log("服务器连接关闭");
    //     };
    //     ws.onerror = function () {
    //       console.log("服务器连接出错");
    //     };
    //     ws.onmessage = function (e) {
    //       // 接收服务器返回的数据
    //       let resData = JSON.parse(e.data);
    //       if (resData.funName === "userCount") {
    //         _this.count = resData.users;
    //         _this.list = resData.chat;
    //         console.log(_this.list, "1234");
    //       } else {
    //         _this.list = [
    //           ..._this.list,
    //           { userId: resData.userId, content: resData.msg },
    //         ];
    //       }
    //     };
    //   }
    // },
  },
  components: {},
  watch: {},
};
</script>
<style scoped>
.chat-box {
  background: #fff;
  width: 500px;
  height: 718px;
  overflow: hidden;
  border: 2px solid #51abff;
  border-radius: 8px;
  padding: 0 10px;
  box-shadow: 5px 2px 2px rgba(10, 16, 20, 0.24), 3px 2px 5px rgba(10, 16, 20, 0.12);
}
.search {
  height: 70px;
  width: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.search /deep/ .el-input__inner {
  background: #f0f0f0;
  border-radius: 4px;
  width: 249px;
  height: 24px;
  line-height: 24px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  border: 1px solid transparent;
}
.search /deep/ .el-input {
  width: 249px;
  height: 24px;
  line-height: 24px;
  border: 1px solid transparent;
}
.search /deep/ .el-input__icon {
  line-height: 24px;
}
.title-main {
  width: 530px;
  /*聊天盒子滑动长度*/
  height: 590px;
  overflow-y: scroll;
}
.send-message {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.send-message-main {
  width: 285px;
  height: 50px;
  display: flex;
  align-items: center;
}
.img-avt {
  width: 28px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.search-main-css /deep/ .el-input__inner {
  border: 1px solid transparent;
  width: 230px;
}
.search-main-css /deep/ .el-input {
  width: 230px;
}
.send-button-css {
  width: 25px;
  height: 25px;
  cursor: pointer;
  background: #51abff;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.send-button-css img {
  width: 15px;
  height: 15px;
}
.message-list-li {
  width: 500px;
  min-height: 50px;
  overflow: hidden;
}
.message-li-box {
  /*white-space: pre-line;*/
  min-height: 30px;
  margin-top: 10px;
  max-width: 200px;
  background: #51abff;
  float: right;
  border-radius: 6px 6px 0px 6px;
  line-height: 20px;
  padding: 5px;
  box-sizing: border-box;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #ffffff;
}
.message-li-text {
  min-height: 10px;
  margin-top: 42px;
  /* text0 字段  input输入框右对齐 且 左边距调整*/
  margin-left: 250px;
  text-align: right;

  max-width: 210px;
  font-family: 'Work Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  letter-spacing: -0.02em;
  color: #51ABFF;
}
.message-avt-img-css {
  width: 35px;
  height: 35px;
  float: right;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 0 0 10px;
}
.message-li-box1 {
  min-height: 30px;
  margin-top: 10px;
  max-width: 200px;
  float: left;
  background: rgba(252, 99, 12);
  border-radius: 6px 6px 6px 0px;
  line-height: 20px;
  padding: 5px;
  box-sizing: border-box;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin-left: 10px;
  letter-spacing: 0.25px;
  color: #ffffff;
}
.message-li-text1 {
  min-height: 5px;
  margin-top: 42px;

  margin-left: 40px;
  text-align: left;
  /*最大文本长度*/
  max-width: 210px;
  float: bottom;
  styleName: Body;
  font-family: 'Work Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  letter-spacing: -0.02em;
  color: #51ABFF;

}


.message-avt-img-css1 {
  width: 40px;
  height: 40px;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 0 0 10px;
}

</style>




// WEBPACK FOOTER //
// src/components/MessageBox.vue